export default __webpack_public_path__ + "static/media/product-6.39ac1185.png";